// https://redux.js.org/usage/configuring-your-store#the-solution-configurestore
import { createReducer as createOrmReducer } from 'redux-orm';

import { appReducer } from './features/app/slice';
import { experienceManagerReducer } from './features/experienceManager/slice';
import { experienceReducer } from './features/experience/slice';

// import { combineReducers, configureStore, createStore } from '@reduxjs/toolkit';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
// import {applyMiddleware } from 'redux';
import orm from './orm';
// import { composeWithDevTools } from 'redux-devtools-extension';

const middlewares: any[] = [];

const rootReducer = combineReducers({
  orm: createOrmReducer(orm),
  app: appReducer,
  experienceManager: experienceManagerReducer,
  experience: experienceReducer,
});


// const persistedReducer = persistReducer(persistConfig, rootReducer);
// export const store = createStore( rootReducer, composeWithDevTools());

// export const store = configureStore(
export const store = configureStore({
  reducer: rootReducer, 
  devTools: process.env.NODE_ENV !== 'production',
});
  

// export const store = configureStore({
//   reducer: rootReducer,
//   devTools: process.env.NODE_ENV !== 'production',
// });

// @ts-ignore
// store.close = () => store.dispatch(END);

// export default store;